import React, { Component } from "react";
import {Modal, Card, Form, Button, Row, Col, Table, Alert, Tab, Tabs, InputGroup, OverlayTrigger, Tooltip, ListGroup, FormLabel, CardBody} from "react-bootstrap";
import CreatableSelect from 'react-select/creatable';
import api from "../../services/api";
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import { formatarValor, formatarValorAPI, tiposUsuarioBotoes } from '../../common/utils';
import AsyncSelect from 'react-select/async';
import ReactQuill from 'react-quill';
import Paginacao from '../../common/pagination';
import { FaEdit, FaTrash } from "react-icons/fa";
import '../ProgramasV2/ProgramasEdit.module.css';

class BotoesAtendimento extends Component {
    constructor(props) {
        super(props);
        this.state = {
            botoes: [],
            botaoSelecionado: [{ titulo: '', descricao: '', formulario_id: '',  callback_funcao: '',  formulario_nome: '', tipo_usuario: '', envia_email: false, email_enderecos: "", email_titulo: "", email_conteudo: "", exibir_botao_monitoria: false, exibir_aba: false, id: null, focusFormulario: false, formularioSearchTimeout: null }],
            programa_id: this.props.programa_id,
            focusFormulario: false,
            erroLoadRegistro: '',
            loading: false,
            page_numb: this.props.page_numb || 1,
            page_limit: this.props.page_limit || 10
        }
    }

    componentDidMount() {
        this.carregarBotoesAtendimento();
    }

    carregarBotoesAtendimento = async () => {
        if (this.state.programa_id) {
            await api.get(`/programas/botoes/?programa_id=${this.state.programa_id}&page=${this.state.page_numb}&page_limit=${this.state.page_limit}`)
            .then(response => {
                this.setState({
                    botoes: {
                        ...response.data,
                        results:response.data.results.map(botao => ({
                            id: botao.id,
                            titulo: botao.titulo,
                            descricao: botao.descricao,
                            formulario_id: botao.formulario_id,
                            formulario_nome: botao.dados_formulario.nome,
                            callback_funcao: botao.callback_funcao,
                            tipo_usuario: botao.tipo_usuario,
                            envia_email: botao.envia_email,
                            email_enderecos: botao.email_enderecos,
                            email_titulo: botao.email_titulo,
                            email_conteudo: botao.email_conteudo,
                            exibir_botao_monitoria: botao.exibir_botao_monitoria,
                            exibir_aba: botao.exibir_aba
                        }))
                    }
                });
            })
            .catch(error => {
                console.error('Erro ao carregar botoes:', error);
                
                let erro_msg = 'Erro ao carregar botoes de atendimento, tente novamente';

                if(error.response && error.response.status === 500){
                    erro_msg = 'Servidor indisponível no momento, tente novamente';
                }

                this.setState({
                    erroLoadRegistro: erro_msg,
                })
            });
        }
    }

    handleBotaoAtendimentoChange = (e, fieldName, bool = false) => {
        if(fieldName === "envia_email" || fieldName === "exibir_botao_monitoria" || fieldName === "exibir_aba"){
            this.setState({ botaoSelecionado: { ...this.state.botaoSelecionado, [fieldName]: bool } });
        }
        else if (fieldName === 'formulario_id') {
            this.setState({ botaoSelecionado: { ...this.state.botaoSelecionado, formulario_id: e.value, formulario_nome: e.label, valor: e.valor } });
        } else if (fieldName === "email_conteudo"){
            this.setState({ botaoSelecionado: { ...this.state.botaoSelecionado, ["email_conteudo"]: e } });
        } else {
            const { name, value } = e.target;
            this.setState({ botaoSelecionado: { ...this.state.botaoSelecionado, [name]: value } });
        }
    }

    handleSalvarBotaoAtendimento = async () => {
        const url = this.state.botaoSelecionado.id ? `/programas/botoes/${this.state.botaoSelecionado.id}/` : '/programas/botoes/';
        const metodo = this.state.botaoSelecionado.id ? 'put' : 'post';
    
        const dadosBotao = {
            titulo: this.state.botaoSelecionado.titulo,
            descricao: this.state.botaoSelecionado.descricao,
            formulario_id: this.state.botaoSelecionado.formulario_id,
            programa_id: this.state.programa_id
        };

        if(this.state.botaoSelecionado.envia_email){
            dadosBotao['envia_email'] = this.state.botaoSelecionado.envia_email;
            dadosBotao['email_titulo'] = this.state.botaoSelecionado.email_titulo;
            dadosBotao['email_enderecos'] = this.state.botaoSelecionado.email_enderecos;
            dadosBotao['email_conteudo'] = this.state.botaoSelecionado.email_conteudo;    
        }

        dadosBotao['exibir_botao_monitoria'] = this.state.botaoSelecionado.exibir_botao_monitoria;
        dadosBotao['exibir_aba'] = this.state.botaoSelecionado.exibir_aba;

        dadosBotao['tipo_usuario'] = (this.state.botaoSelecionado.tipo_usuario) ? this.state.botaoSelecionado.tipo_usuario : '';
        dadosBotao['callback_funcao'] = (this.state.botaoSelecionado.callback_funcao) ? this.state.botaoSelecionado.callback_funcao : '';
        
        api({
            method: metodo,
            url: url,
            data: dadosBotao,
        })
        .then(response => {
            
            const MySwal = withReactContent(Swal)
            const textSwal = (this.state.botaoSelecionado.id) ? 'Botao atualizado com sucesso' : 'Botao cadastrado com sucesso';

            MySwal.fire({
                title: <p>{textSwal}</p>,
                icon: 'success',
                showCloseButton: true,
            })

            this.carregarBotoesAtendimento();
            this.handleCloseModalBotoesAtendimento();
            
        })
        .catch(error => {
            let erro_msg = 'Erro ao cadastrar o botao, verifique os campos e tente novamente';         
            let content = '';   

            if(error.response && error.response.status === 500){
                erro_msg = 'Servidor indisponível no momento';
            }
            else if(error.response && error.response.status === 400){
                const campos = error.response.data;                
                
                //percorre os campos com erro
                for (let key in campos){
                    var value = campos[key];

                    if(key == 'titulo') {
                        content += `<br>&bull; Título: ${value}`;
                    }
                    if(key == 'valor') {
                        content += `<br>&bull; Descrição: ${value}`;
                    }
                    if(key == 'formulario_id') {
                        content += `<br>&bull; Id do formulário: ${value}`;
                    }
                }
            }

            const MySwal = withReactContent(Swal)
            MySwal.fire({
                icon: 'error',
                showCloseButton: true,
                title: <p>{erro_msg}</p>,
                html: content,
            })
        });
    }

    removerBotaoAtendimento = (botao) => {
        const MySwal = withReactContent(Swal);
    
        MySwal.fire({
            title: 'Remover botão de atendimento?',
            text: "Tem certeza que deseja remover o botão " + botao.titulo + " de atendimento?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sim, remover!',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (result.isConfirmed) {
                if (botao.id) {
                    api({
                        method: 'delete',
                        url: `/programas/botoes/${botao.id}/`,
                    })
                    .then(response => {
                                              
                        const MySwal = withReactContent(Swal)
                        const textSwal = 'Botão de atendimento removido com sucesso';

                        MySwal.fire({
                            title: <p>{textSwal}</p>,
                            icon: 'success',
                            showCloseButton: true,
                        })

                        this.carregarBotoesAtendimento();
                    })
                    .catch(error => {
                        let erro_msg = 'Erro ao remover o botão, tente novamente';            

                        if(error.response && error.response.status === 500){
                            erro_msg = 'Servidor indisponível no momento';
                        }
                        else if(error.response && error.response.status === 400){
                            const campos = error.response.data;       
                            
                        }

                        const MySwal = withReactContent(Swal)
                        MySwal.fire({
                            icon: 'error',
                            showCloseButton: true,
                            title: <p>{erro_msg}</p>,
                        })
                    });

                } else {
                    this.setState(prevState => ({
                        botoes_atendimento: prevState.botoes_atendimento.filter((_, i) => i !== index),
                    }));
        
                    MySwal.fire(
                        'Removido!',
                        'O botão de atendimento foi removido.',
                        'success'
                    );
                }
            }
        });
    };

    handleShowModalBotoesAtendimento = (botao = []) => {
        this.setState({ showModalBotoesAtendimento: true, botaoSelecionado: botao });
    }

    handleCloseModalBotoesAtendimento = () => {
        this.setState({ showModalBotoesAtendimento: false, botaoSelecionado: [], focusFormulario: false });
    }

    onClickPaginaBotoesAtendimento = (num_page) => {
        this.setState({
            loading: true,
            page_numb: num_page
        }, () => {
            this.carregarBotoesAtendimento(num_page)
        });
    };

    carregarFormularios = async (inputValue) => {
        if(!this.state.focusFormulario){
            return [];
        }

        try {
            const response = await api.get(`/formularios/?nome=${inputValue}&status=1&tipo=normal`);
            const opcoes = response.data.results.map(formulario => ({
                value: formulario.id,
                label: formulario.nome
            }));
            return opcoes;
        } catch (error) {
            console.error('Erro ao carregar formulários:', error);
            return [];
        }
    };


    render() {
        return (
            <>
            <Card className="cardDestaque mt-4">
                <Card.Body>                   
                    <Row className="align-items-center mb-3">
                        <Col sm={6} lg={6}>
                            <h6><strong>Botoes de Atendimento</strong></h6>
                        </Col>
                        <Col sm={6} xs={6} className="text-end">                       
                            <Button type="button" variant="success" className="btn-sm mt-3" disabled={this.state.loading} onClick={() => this.handleShowModalBotoesAtendimento()}>
                                {this.state.loading ? <span className="spinner-border spinner-border-sm"></span> : 'Adicionar Botao'}                                       
                            </Button>
                        </Col>
                    </Row>
                    {('results' in this.state.botoes && this.state.botoes.results.length > 0) ? (
                        <Row>
                            <Col sm={12} lg={12}>
                                <Table responsive className="custom-table">
                                    <thead>
                                        <tr>
                                            <th>ID</th>
                                            <th>Título</th>
                                            <th>Descrição</th>
                                            <th>Formulário</th>
                                            <th>Opções</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.botoes.results.map((botao, index) => ( 
                                            <tr key={index}>
                                                <td className="bg-id">#{botao.id}</td>
                                                <td className="td-border">{botao.titulo}</td>
                                                <td className="td-border">{botao.descricao}</td>
                                                <td className="td-border"><a href={`/formularios/edit/${botao.formulario_id}`} target="_blank" rel="noopener noreferrer">{botao.formulario_nome}</a></td>
                                                <td>
                                                    <Button variant="secondary" size="sm" className="me-2" onClick={() => this.handleShowModalBotoesAtendimento(botao)}>
                                                        <FaEdit /> Editar
                                                    </Button>  
                                                    <Button variant="danger" size="sm" className="me-2" onClick={() => this.removerBotaoAtendimento(botao)}>
                                                        <FaTrash /> Remover
                                                    </Button>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>
                                    {'results' in this.state.botoes && this.state.botoes.results.length > 0 && (
                                        <Paginacao dados={this.state.botoes} limit={this.state.page_limit} loading={this.state.loading} page_numb={this.state.page_numb} _onClickPagina={this.onClickPaginaBotoesAtendimento} />
                                    )}
                            </Col>
                        </Row>   
                    ) : (
                        <p>Nenhum botao de atendimento cadastrado até o momento</p>
                    )}
                            
                </Card.Body>                
            </Card>

            <Modal show={this.state.showModalBotoesAtendimento} onHide={this.handleCloseModalBotoesAtendimento} size="xl">
                <Modal.Header closeButton>
                    <Modal.Title>
                        {this.state.botaoSelecionado.id ? 'Editar Botao #' + this.state.botaoSelecionado.id : 'Adicionar Botao'}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <h4>Botões Atendimento</h4>
                            <div className="row-list">
                                <Row>                                                
                                    <Col sm={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Título</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="titulo"
                                                value={this.state.botaoSelecionado.titulo} 
                                                onChange={e => this.handleBotaoAtendimentoChange(e, 'titulo')}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col sm={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Formulário</Form.Label>
                                            <AsyncSelect
                                                key={this.state.focusFormulario}
                                                loadOptions={(inputValue) => {
                                                    return new Promise((resolve) => {
                                                        clearTimeout(this.state.formularioSearchTimeout);
                                                        this.state.formularioSearchTimeout = setTimeout(() => {
                                                            resolve(this.carregarFormularios(inputValue));
                                                        }, 700);
                                                    });
                                                }}
                                                onFocus={() => {
                                                    this.setState({
                                                        focusFormulario: true
                                                    });
                                                }}
                                                autoFocus={this.state.focusFormulario}
                                                openMenuOnFocus={this.state.focusFormulario}
                                                defaultOptions
                                                name="formulario_id"
                                                placeholder="Buscar formulário..."
                                                noOptionsMessage={() => "Nenhum formulário encontrado"}
                                                onChange={e => this.handleBotaoAtendimentoChange(e, 'formulario_id')}
                                                value={this.state.botaoSelecionado.formulario_id ? { value: this.state.botaoSelecionado.formulario_id, label: this.state.botaoSelecionado.formulario_nome } : null}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col sm={12}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Descrição</Form.Label>
                                            <Form.Control 
                                                as="textarea"                                                             
                                                placeholder="Descrição" 
                                                name="descricao"
                                                value={this.state.botaoSelecionado.descricao} 
                                                onChange={e => this.handleBotaoAtendimentoChange(e, 'descricao')}
                                                rows={3}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col sm={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Callback</Form.Label>
                                            <Form.Control 
                                                type="text"                                                             
                                                name="callback_funcao"
                                                value={this.state.botaoSelecionado.callback_funcao} 
                                                onChange={e => this.handleBotaoAtendimentoChange(e, 'callback_funcao')}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col sm={4}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Restringir para Usuário</Form.Label>
                                            <Form.Control as="select" name="tipo_usuario" value={this.state.botaoSelecionado.tipo_usuario} onChange={e => this.handleBotaoAtendimentoChange(e, 'tipo_usuario')}>
                                                <option value="">Selecione o responsável</option>
                                                {Object.entries(tiposUsuarioBotoes).map(([value, label]) => (
                                                    <option key={value} value={value}>{label}</option>
                                                ))}
                                            </Form.Control>
                                        </Form.Group>
                                    </Col>
                                    <Col sm={2} xs={12}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Exibir botão de monitoria?</Form.Label>
                                            <div>
                                                <Button 
                                                    name="exibir_botao_monitoria"
                                                    variant={this.state.botaoSelecionado.exibir_botao_monitoria ? "success" : "outline-secondary"}
                                                    onClick={e => this.handleBotaoAtendimentoChange(e, 'exibir_botao_monitoria', true)}>
                                                    Sim
                                                </Button>
                                                {' '}
                                                <Button 
                                                    name="exibir_botao_monitoria"
                                                    variant={!this.state.botaoSelecionado.exibir_botao_monitoria ? "danger" : "outline-secondary"}
                                                    onClick={e => this.handleBotaoAtendimentoChange(e, 'exibir_botao_monitoria', false)}>
                                                    Não
                                                </Button>
                                            </div>
                                        </Form.Group>
                                    </Col>
                                    <Col sm={2} xs={12}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Exibir como aba?</Form.Label>
                                            <div>
                                                <Button 
                                                    name="exibir_aba"
                                                    variant={this.state.botaoSelecionado.exibir_aba ? "success" : "outline-secondary"}
                                                    onClick={e => this.handleBotaoAtendimentoChange(e, 'exibir_aba', true)}>
                                                    Sim
                                                </Button>
                                                {' '}
                                                <Button 
                                                    name="exibir_aba"
                                                    variant={!this.state.botaoSelecionado.exibir_aba ? "danger" : "outline-secondary"}
                                                    onClick={e => this.handleBotaoAtendimentoChange(e, 'exibir_aba', false)}>
                                                    Não
                                                </Button>
                                            </div>
                                        </Form.Group>
                                    </Col>
                                    <Col sm={2} xs={12}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Envia formulário por e-mail?</Form.Label>
                                            <div>
                                                <Button 
                                                    name="envia_email"
                                                    variant={this.state.botaoSelecionado.envia_email ? "success" : "outline-secondary"}
                                                    onClick={e => this.handleBotaoAtendimentoChange(e, 'envia_email', true)}>
                                                    Sim
                                                </Button>
                                                {' '}
                                                <Button 
                                                    name="envia_email"
                                                    variant={!this.state.botaoSelecionado.envia_email ? "danger" : "outline-secondary"}
                                                    onClick={e => this.handleBotaoAtendimentoChange(e, 'envia_email', false)}>
                                                    Não
                                                </Button>
                                            </div>
                                        </Form.Group>
                                    </Col>
                                </Row>
                                {this.state.botaoSelecionado.envia_email && (
                                    <Card className="cardDestaque">
                                        <Card.Body>                    
                                            <Row>
                                                <h4>Formulário de E-mail</h4>
                                                <Col sm={6} xs={12}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Título</Form.Label>
                                                        <Form.Control 
                                                            type="text"                                                             
                                                            name="email_titulo"
                                                            value={this.state.botaoSelecionado.email_titulo} 
                                                            onChange={e => this.handleBotaoAtendimentoChange(e, 'email_titulo')}
                                                        />
                                                    </Form.Group>
                                                </Col>
                                                <Col sm={6} xs={12}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Destinatários</Form.Label>
                                                        <Form.Control 
                                                            type="text"                                                             
                                                            name="email_enderecos"
                                                            value={this.state.botaoSelecionado.email_enderecos} 
                                                            onChange={e => this.handleBotaoAtendimentoChange(e, 'email_enderecos')}
                                                        />
                                                    </Form.Group>
                                                </Col>
                                                <Col sm={12} xs={12}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Conteúdo do e-mail</Form.Label>
                                                        <ReactQuill
                                                            value={this.state.botaoSelecionado.email_conteudo}
                                                            name="email_conteudoo"
                                                            onChange={e => this.handleBotaoAtendimentoChange(e, 'email_conteudo')}
                                                            theme="snow" // Tema do editor, pode ser "snow" ou "bubble"
                                                            modules={{
                                                                toolbar: [
                                                                [{ header: '1' }, { header: '2' }, { font: [] }],
                                                                [{ list: 'ordered' }, { list: 'bullet' }],
                                                                ['bold', 'italic', 'underline'],
                                                                ['link', 'image'],
                                                                [{ align: [] }],
                                                                ['clean'],
                                                                ],
                                                            }}
                                                            placeholder="Digite seu conteúdo aqui"
                                                            className="form-control"
                                                        />
                                                    </Form.Group>
                                                </Col>
                                            </Row>
                                        </Card.Body>
                                    </Card>
                                )}
                            </div>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={this.handleCloseModalBotoesAtendimento}>
                        Fechar
                    </Button>
                    <Button variant="primary" onClick={this.handleSalvarBotaoAtendimento}>
                        Salvar
                    </Button>
                </Modal.Footer>
            </Modal>
            </>
        );
    }
}

export default BotoesAtendimento;

